import { render, staticRenderFns } from "./PreguntaText.vue?vue&type=template&id=dc2c9566&"
import script from "./PreguntaText.vue?vue&type=script&lang=js&"
export * from "./PreguntaText.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports